






























import Vue from 'vue'
import Component from 'vue-class-component'
import DisplaySkillItem from '@app/componentlib/src/views/components/DisplaySkillItem.vue'
import { DisplayItem, ItemTypes } from '@app/componentlib/src/common/types/profileTypes'
import { enumFromString } from '@app/componentlib/src/application/helpers/globalHelpers'
import { AppModule } from '@app/componentlib/src/store/modules/app'
import { ga } from '@app/componentlib/src/application/analytics'

@Component<DisplaySkills>({
  props: {
    title: String,
    items: Array,
    itemProp: String,
    includeDate: Boolean,
    profileLink: String,
    type: String,
    tooltip: String
  },
  components: {
    DisplaySkillItem
  }
})

export default class DisplaySkills extends Vue {
  /**
   * Props variables
   */
  itemProp: string | undefined
  items: [] | undefined
  type: string | undefined
  tooltip: string | undefined

  /**
   * Component state variables
   */
  cvId: number | undefined = undefined


  /**
   * Lifecycle
   */
  mounted () {
    if(this.type !== undefined && this.items !== undefined) {
      const type = enumFromString(ItemTypes, this.type)
      this.items.forEach((item: DisplayItem) => (item.type = type) && (item.Id = item.id ?? item.Id))
    }
  }


  /**
   * Getters
   */
  get t (): any {
    return AppModule.translations
  }

  get orderedItems (): any {
    if(this.items !== undefined && this.items.length > 1)
      return this.items.sort((a: DisplayItem, b: DisplayItem) => (a.sortOrder !== undefined ? a.sortOrder : 0) - (b.sortOrder !== undefined ? b.sortOrder : 0))
    else
      return this.items
  }

  /**
   * Methods
   */
  goToProfile () {
    ga.event({
      action: 'Go to profile - Display Skills',
      category: 'CV Tool',
      label: this.type !== undefined ? this.type : 'undefined'
    })
  }

}
